import React, { useEffect, useState } from 'react';
import { CONSENT_EVENT, getAnalyticsConsent, isAnalyticsConfigured, setAnalyticsConsent } from '../analytics';

export default function AnalyticsPreferences() {
  const [consent, setConsent] = useState(getAnalyticsConsent);
  useEffect(() => {
    const update = (event) => setConsent(event.detail);
    window.addEventListener(CONSENT_EVENT, update);
    return () => window.removeEventListener(CONSENT_EVENT, update);
  }, []);
  if (!isAnalyticsConfigured()) return null;
  return (
    <div>
      <p role="status">Optional analytics is {consent === 'granted' ? 'on' : 'off'} in this browser.</p>
      <button type="button" className="cta-button secondary" onClick={() => setAnalyticsConsent(consent === 'granted' ? 'denied' : 'granted')}>
        {consent === 'granted' ? 'Turn off optional analytics' : 'Allow optional analytics'}
      </button>
    </div>
  );
}
